module.exports = __webpack_public_path__ + "static/media/study.3de48f1c.jpg";